import USBLoadingSpinner from '@usb-shield/react-loading-spinner';
const LoadingSpinner = () => {
  return (    
    <div className="flex h-screen items-center justify-center">
      <USBLoadingSpinner
        label=" "
        dataTestId="portal-spinner"
        addClasses="portal-spinner mt-0"
      />
    </div>
  );
};
 
export default LoadingSpinner;